import React from 'react';
import { Link } from '../../../RouterCompatibility';
import { createSelector } from 'reselect';
import { I18nFormatter } from '../../../../utils/I18n/I18n';
import UserStore from '../../../../stores/UserStore';
import { getPath } from '../../../../utils/Router';

const accountEntries = (state) => state.publisherAccountEntries.list;

export const getHeaderNames = createSelector(
    () => {
        const staticNames = UserStore.getTranslation().dataTable.headers;
        return [
            staticNames.id,
            staticNames.date,
            staticNames.balanceBefore,
            staticNames.diff,
            staticNames.balanceAfter,
            staticNames.reason
        ];
    }
);

export const getAccountEntries = createSelector(
    accountEntries,
    (accountEntries = []) => {
        let list = [];

        accountEntries.map((item) => {
            let diffAmount = parseInt(item.sum.amount) > 0 ? '+' + item.sum.amount : item.sum.amount;
            const payoutNames = UserStore.getTranslation().payoutPage;

            list.push({
                id:(
                    <div>
                        <span className="wrap__desktop">{item.id}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.id}</div>
                            <div className="row-value">{item.id}</div>
                        </div>
                    </div>
                ),
                createdAt: (
                    <div>
                        <span className="wrap__desktop">{item.created_at_formatted /* I18nFormatter.fullDateTime(item.created_at) */}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.date}</div>
                            <div className="row-value">{item.created_at_formatted /* I18nFormatter.fullDateTime(item.created_at) */}</div>
                        </div>
                    </div>
                ),
                balanceBefore: (
                    <div>
                        <span className="wrap__desktop">{I18nFormatter.currency(item.balance_before.amount, item.balance_before.currency)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.balanceBefore}</div>
                            <div className="row-value">{I18nFormatter.currency(item.balance_before.amount, item.balance_before.currency)}</div>
                        </div>
                    </div>
                ),
                difference: (
                    <div>
                        <span className="wrap__desktop">{_getColorNumber(item.sum.amount, I18nFormatter.currency(diffAmount, item.sum.currency))}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.difference}</div>
                            <div className="row-value">{_getColorNumber(item.sum.amount, I18nFormatter.currency(diffAmount, item.sum.currency))}</div>
                        </div>
                    </div>
                ),
                balanceAfter: (
                    <div>
                        <span className="wrap__desktop">{I18nFormatter.currency(item.balance_after.amount, item.balance_after.currency)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.balanceAfter}</div>
                            <div className="row-value">{I18nFormatter.currency(item.balance_after.amount, item.balance_after.currency)}</div>
                        </div>
                    </div>
                ),
                source: (
                    <div>
                        <span className="wrap__desktop">{_getSourceAccountEntry(item.source)}</span>
                        <div className="wrap__mobile">
                            <div className="row-value">{_getSourceAccountEntry(item.source)}</div>
                        </div>
                    </div>
                )
            });
        });

        return list;
    }
);

export const getSelectOptions = createSelector(
    () => {
        const accountEntryReason = UserStore.getTranslation().accountEntryReason;
        return [{
            title: accountEntryReason.conversion,
            value: 'conversion'
        },{
            title: accountEntryReason.currency_conversion,
            value: 'currency_conversion'
        },{
            title: accountEntryReason.payout_new,
            value: 'payout_new'
        },{
            title: accountEntryReason.payout_paid,
            value: 'payout_paid'
        },{
            title: accountEntryReason.payout_canceled,
            value: 'payout_canceled'
        },{
            title: accountEntryReason.custom,
            value: 'custom'
        },{
            title: accountEntryReason.custom_with_goal,
            value: 'custom_with_goal'
        },{
            title: accountEntryReason.payout_cap_automatic_correction,
            value: 'payout_cap_automatic_correction'
        }];
    }
);

const _getSourceAccountEntry = (source) => {
    const accountEntryReason = UserStore.getTranslation().accountEntryReason;
    let value = accountEntryReason[source.value];

    if (source.value === 'conversion' && source.parameters.id) {
        value = <Link to={getPath('conversion', {id: source.parameters.id})}>{value}</Link>;
    } else if (source.value === 'payout_new' && source.parameters.id) {
        value = <Link to={getPath('payoutItem', {id: source.parameters.id})}>{value}</Link>;
    } else if (source.value === 'payout_paid' && source.parameters.id) {
        value = <Link to={getPath('payoutItem', {id: source.parameters.id})}>{value}</Link>;
    } else if (source.value === 'payout_canceled' && source.parameters.id) {
        value = <Link to={getPath('payoutItem', {id: source.parameters.id})}>{value}</Link>;
    } else if (source.value === 'custom' && source.parameters.reason) {
        value = `${value}: ${source.parameters.reason}`;
    } else if (source.value === 'custom_with_goal' && source.parameters.reason) {
        value = `${value}: ${source.parameters.reason}`;
    } else if (source.value === 'payout_cap_automatic_correction' && source.parameters.reason) {
        value = `${value}: ${source.parameters.reason}`;
    }

    return value;
};

const _getColorNumber = (number, value) => {
    return <span className={number > 0 ? 'green' : 'red'}>{value}</span>
};
